import { Injectable } from '@angular/core';
import { Pagination } from '../../models/base';
import {
  Product,
  ProductCategory,
  ProductCollection,
} from '../../models/product';
import { HttpService } from './http.service';

export enum ProductOrderBy {
  CREATED_AT = 'created_at',
  RECOMMENDED = 'recommended',
  PRICE_ASC = 'price_asc',
  PRICE_DESC = 'price_desc',
}

@Injectable({
  providedIn: 'root',
})
export class ProductApiService {
  constructor(private http: HttpService) { }
  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/product' + path, queryMap);
  }

  private productCategories: ProductCategory[] = [];
  async findProductCategories(): Promise<ProductCategory[]> {
    if (this.productCategories.length > 0) {
      return this.productCategories;
    }
    const url = this.buildurl('/categories');
    this.productCategories = await this.http.fget(url);
    return this.productCategories;
  }

  findProducts({
    query,
    page,
    color,
    sizes,
    page_size,
    category_ids,
    order_by,
    tags,
  }: {
    query: string;
    page: number;
    color?: string;
    sizes?: string[];
    page_size: number;
    category_ids?: number[];
    order_by?: string;
    tags: string[];
  }): Promise<Pagination<Product>> {
    const url = this.buildurl('/products', {
      query,
      color,
      sizes,
      page,
      page_size,
      category_ids,
      order_by,
      tags,
    });
    return this.http.fget(url);
  }

  getProductCollection(no: string): Promise<ProductCollection> {
    const url = this.buildurl('/collection/' + no);
    return this.http.fget(url);
  }

  findProductCollectionProducts(
    no: string,
    {
      page,
      page_size,
      order_by,
      category_ids,
      color,
      sizes,
    }: {
      page?: number;
      page_size?: number;
      order_by?: string;
      category_ids?: number[];
      color?: string;
      sizes?: string[];
    }
  ): Promise<Pagination<Product>> {
    const url = this.buildurl(`/collection/${no}/products`, {
      page,
      page_size,
      order_by,
      category_ids,
      color,
      sizes,
    });
    return this.http.fget(url);
  }

  getProduct(no: string): Promise<Product> {
    const url = this.buildurl(`/product/${no}`);
    return this.http.fget(url);
  }

  findProductRecommended(
    no: string,
    { limit }: { limit: number }
  ): Promise<Product[]> {
    const url = this.buildurl(`/product/${no}/recommended`, { limit });
    return this.http.fget(url);
  }

  findRecentlyViewedProducts({ limit }: { limit: number }): Promise<Product[]> {
    const url = this.buildurl('/recently-viewed', { limit });
    return this.http.fget(url);
  }
}
